export default __webpack_public_path__ + "static/media/pantalla-tactil.eebbfd9e.png";